import { render, staticRenderFns } from "./myRobotSetUp.vue?vue&type=template&id=295f155b&"
import script from "./myRobotSetUp.vue?vue&type=script&lang=js&"
export * from "./myRobotSetUp.vue?vue&type=script&lang=js&"
import style0 from "./myRobotSetUp.vue?vue&type=style&index=0&id=295f155b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports